import { Component } from "@angular/core";
import { PoBreadcrumb, PoNotificationService } from "@po-ui/ng-components";
import { TasksService } from "../../services/tasks.service";
import { XmlService } from "../../services/xml.service";

@Component({
    selector: 'erpcloud-config',
    templateUrl: './config.component.html',
    styleUrls: ['./config.component.css'],
    standalone: false
})
export class ConfigComponent {

    isLoading: boolean = false;

    diretorioSource: string = '';
    diretorioDestino: string = '';

    costumerDiretorioSource: string = '';
    costumerAno: string = '';
    costumerDiretorioDestino: string = '';

    constructor(private readonly tasksService: TasksService,
        private readonly poNotificationService: PoNotificationService,
        private readonly xmlservice: XmlService
    ) { }

    readonly breadcrumb: PoBreadcrumb = {
        items: [{ label: 'Home', link: '/home' }, { label: 'Configurações' }]
    };

    replicateDirectory() {

        if (!this.diretorioSource || !this.diretorioDestino) {
            this.poNotificationService.error("É necessário informar os parametros para rotina selecionada");
            return;
        }

        this.isLoading = true;
        this.tasksService.replicateDirectory(this.diretorioSource, this.diretorioDestino)
            .subscribe(data => {

                console.log(data);
                this.poNotificationService.success("Solicitação enviada com sucesso!");
                this.diretorioSource = '';
                this.diretorioDestino = '';

                this.isLoading = false;
            }, error => {

                console.log(error);
                this.isLoading = false;

            });
    }

    replicateCostumer() {

        if (!this.costumerAno || !this.costumerDiretorioDestino || !this.costumerDiretorioSource) {
            this.poNotificationService.error("É necessário informar os parametros para rotina selecionada");
            return;
        }

        this.isLoading = true;
        this.tasksService.replicateCostumer(this.costumerDiretorioSource, this.costumerAno, this.costumerDiretorioDestino)
            .subscribe(data => {

                console.log(data);
                this.poNotificationService.success("Solicitação enviada com sucesso!");
                this.costumerDiretorioSource = '';
                this.costumerAno = '';
                this.costumerDiretorioDestino = '';

                this.isLoading = false;

            }, error => {

                console.log(error);
                this.isLoading = false;

            });
    }

}
